import { render, staticRenderFns } from "./AutoCompletion.vue?vue&type=template&id=4087b5a8"
import script from "./AutoCompletion.vue?vue&type=script&lang=ts"
export * from "./AutoCompletion.vue?vue&type=script&lang=ts"
import style0 from "./AutoCompletion.vue?vue&type=style&index=0&id=4087b5a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports